module.exports = __webpack_public_path__ + "static/media/snoopyshowerrain02.9fe133d3.gif";